// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ProductType } from '../Instruments/ProductType';
import { OperationType } from '../Trading/OperationType';
import { OrderExecutionType } from '../Trading/OrderExecutionType';
import { OrderStatus } from '../Trading/OrderStatus';
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectOrderHistoryMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_ORDER_HISTORY);
        this.ClientOrderId = '';
        this.Comment = '';
        this.PutCall = 0;
        this.StrikePrice = 0;
        this.Status = OrderStatus.UNKNOWN;
        this.ProductType = ProductType.General;
        this.FAccount = '';
        this.FBuySell = OperationType.Buy;
        this.FOrderNumber = '';
        this.FOrderType = 0;
        this.FPrice = 0;
        this.FQuantity = 0;
        this.FRoute = null;
        this.FRemoteId = '';
        this.FStopLimit = 0;
        this.FSymbol = '';
        this.FUTCDateTime = null;
        this.FTimeInForce = 0;
        this.expDate = null;
        this.externalOrderID = null;
        this.externalTradeID = null;
        this.FLastUpdateTime = null;
        this.active = false;
        this.boundToOrderId = '-1';
        this.FOrderCreatedByUser = null;
        this.FDisClosedQuantity = 0;
        this.FFilledQuantity = 0;
        this.FRemainingQuantity = 0;
        this.eventType = OrderExecutionType.UNKNOWN;
        this.leverage = null;
        this.FPositionId = '-1';
    }
    get Account() {
        return this.FAccount;
    }
    set Account(val) {
        this.FAccount = val;
    }
    get BuySell() {
        return this.FBuySell;
    }
    set BuySell(val) {
        this.FBuySell = val;
    }
    get OrderNumber() {
        return this.FOrderNumber;
    }
    set OrderNumber(val) {
        this.FOrderNumber = val;
    }
    get OrderType() {
        return this.FOrderType;
    }
    set OrderType(val) {
        this.FOrderType = val;
    }
    get Price() {
        return this.FPrice;
    }
    set Price(val) {
        this.FPrice = val;
    }
    get Quantity() {
        return this.FQuantity;
    }
    set Quantity(val) {
        this.FQuantity = val;
    }
    get Route() {
        return this.FRoute;
    }
    set Route(val) {
        this.FRoute = val;
    }
    get RemoteId() {
        return this.FRemoteId;
    }
    set RemoteId(val) {
        this.FRemoteId = val;
    }
    get StopLimit() {
        return this.FStopLimit;
    }
    set StopLimit(val) {
        this.FStopLimit = val;
    }
    get Symbol() {
        return this.FSymbol;
    }
    set Symbol(val) {
        this.FSymbol = val;
    }
    get UTCDateTime() {
        return this.FUTCDateTime;
    }
    set UTCDateTime(val) {
        this.FUTCDateTime = val;
    }
    get TimeInForce() {
        return this.FTimeInForce;
    }
    set TimeInForce(val) {
        this.FTimeInForce = val;
    }
    get ExpDate() {
        return this.expDate;
    }
    set ExpDate(val) {
        this.expDate = val;
    }
    get LastUpdateTime() {
        return this.FLastUpdateTime;
    }
    set LastUpdateTime(val) {
        this.FLastUpdateTime = val;
    }
    get Active() {
        return this.active;
    }
    set Active(val) {
        this.active = val;
    }
    get BoundToOrderId() {
        return this.boundToOrderId;
    }
    set BoundToOrderId(val) {
        this.boundToOrderId = val;
    }
    get OrderCreatedByUser() {
        return this.FOrderCreatedByUser;
    }
    set OrderCreatedByUser(val) {
        this.FOrderCreatedByUser = val;
    }
    get DisClosedQuantity() {
        return this.FDisClosedQuantity;
    }
    set DisClosedQuantity(val) {
        this.FDisClosedQuantity = val;
    }
    get FilledQuantity() {
        return this.FFilledQuantity;
    }
    set FilledQuantity(val) {
        this.FFilledQuantity = val;
    }
    get RemainingQuantity() {
        return this.FRemainingQuantity;
    }
    set RemainingQuantity(val) {
        this.FRemainingQuantity = val;
    }
    get EventType() {
        return this.eventType;
    }
    set EventType(val) {
        this.eventType = val;
    }
    get ExternalOrderId() {
        return this.externalOrderID;
    }
    set ExternalOrderId(val) {
        this.externalOrderID = val;
    }
    get ExternalTradeId() {
        return this.externalTradeID;
    }
    set ExternalTradeId(val) {
        this.externalTradeID = val;
    }
    get Leverage() {
        return this.leverage;
    }
    set Leverage(val) {
        this.leverage = val;
    }
    get PositionId() {
        return this.FPositionId;
    }
    set PositionId(val) {
        this.FPositionId = val;
    }
}
